'use client'

import { CardProps } from '../../sections/GalleryWithTabs/Card';
import { GalleryWithTabs, GalleryWithTabsProps } from '../../sections/GalleryWithTabs/GalleryWithTabs'
import Image from 'next/image'

type ImageProps = { src: string; alt: string };

const transformCardToNewFormat = (card: any, preload: boolean, tabIndex: number): CardProps<ImageProps> => {
  if (!card.image || !card.image.render) {
    return {
      ...card,
      image: {
        props: {
          src: !card?.image?.props?.src ? card.imageUrl : card.image.props.src || '',
          alt: !card?.image?.props?.alt ? '' : card.image.props.alt || '',
        },
        render: (props: ImageProps) => <Image {...props} width={800} height={600} loading={preload && tabIndex < 1 ? 'eager' : 'lazy'} priority={preload && tabIndex < 1}/>,
      },
    };
  }
  return card;
};

export default (compProps: GalleryWithTabsProps<ImageProps>) => {
  const newProps = {
    ...compProps,
    tabs: compProps.tabs.map((tab, tabIndex) => ({
      ...tab,
      cards: tab.cards.map((card) => transformCardToNewFormat(card, compProps.preload || false, tabIndex)),
    })),
  };

  return <GalleryWithTabs {...newProps} />;
};
